var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/components/NavigateHref.tsx
import React from "react";
import { Fragment, jsx } from "react/jsx-runtime";
var NavigateHref = ({ href }) => {
  React.useEffect(() => {
    window.location.replace(href);
  }, [href]);
  return /* @__PURE__ */ jsx(Fragment, {});
};

// src/geo/index.ts
var geo_exports = {};
__export(geo_exports, {
  countries: () => countries_default,
  states: () => states_exports,
  toList: () => toList
});

// src/geo/countries.ts
var countries_default = [
  {
    name: "Argentina",
    iso: "AR"
  },
  {
    name: "Australia",
    iso: "AU"
  },
  {
    name: "Austria",
    iso: "AT"
  },
  {
    name: "Belgium",
    iso: "BE"
  },
  {
    name: "Bermuda",
    iso: "BM"
  },
  {
    name: "Bulgaria",
    iso: "BG"
  },
  {
    name: "Canada",
    iso: "CA"
  },
  {
    name: "Cayman Islands",
    iso: "KY"
  },
  {
    name: "Chile",
    iso: "CL"
  },
  {
    name: "Colombia",
    iso: "CO"
  },
  {
    name: "Croatia",
    iso: "HR"
  },
  {
    name: "Cyprus",
    iso: "CY"
  },
  {
    name: "Czech Republic",
    iso: "CZ"
  },
  {
    name: "Denmark",
    iso: "DK"
  },
  {
    name: "Estonia",
    iso: "EE"
  },
  {
    name: "Finland",
    iso: "FI"
  },
  {
    name: "France",
    iso: "FR"
  },
  {
    name: "Germany",
    iso: "DE"
  },
  {
    name: "Greece",
    iso: "GR"
  },
  {
    name: "Guadeloupe (French territory)",
    iso: "GP"
  },
  {
    name: "Hong Kong",
    iso: "HK"
  },
  {
    name: "Hungary",
    iso: "HU"
  },
  {
    name: "Iceland",
    iso: "IS"
  },
  {
    name: "India",
    iso: "IN"
  },
  {
    name: "Indonesia",
    iso: "ID"
  },
  {
    name: "Ireland",
    iso: "IE"
  },
  {
    name: "Israel",
    iso: "IL"
  },
  {
    name: "Italy",
    iso: "IT"
  },
  {
    name: "Jamaica",
    iso: "JM"
  },
  {
    name: "Japan",
    iso: "JP"
  },
  {
    name: "Latvia",
    iso: "LV"
  },
  {
    name: "Lithuania",
    iso: "LT"
  },
  {
    name: "Luxembourg",
    iso: "LU"
  },
  {
    name: "Macao",
    iso: "MO"
  },
  {
    name: "Malaysia",
    iso: "MY"
  },
  {
    name: "Malta",
    iso: "MT"
  },
  {
    name: "Mexico",
    iso: "MX"
  },
  {
    name: "Micronesia",
    iso: "FM"
  },
  {
    name: "Netherlands",
    iso: "NL"
  },
  {
    name: "New Zealand",
    iso: "NZ"
  },
  {
    name: "Norway",
    iso: "NO"
  },
  {
    name: "Paraguay",
    iso: "PY"
  },
  {
    name: "Peru",
    iso: "PE"
  },
  {
    name: "Philippines",
    iso: "PH"
  },
  {
    name: "Poland",
    iso: "PL"
  },
  {
    name: "Portugal",
    iso: "PT"
  },
  {
    name: "Reunion (French territory)",
    iso: "RE"
  },
  {
    name: "Romania",
    iso: "RO"
  },
  {
    name: "Saint Barthelemy (French territory)",
    iso: "BL"
  },
  {
    name: "Serbia",
    iso: "RS"
  },
  {
    name: "Singapore",
    iso: "SG"
  },
  {
    name: "Slovakia",
    iso: "SK"
  },
  {
    name: "Slovenia",
    iso: "SI"
  },
  {
    name: "South Africa",
    iso: "ZA"
  },
  {
    name: "South Korea",
    iso: "KR"
  },
  {
    name: "Spain",
    iso: "ES"
  },
  {
    name: "Sweden",
    iso: "SE"
  },
  {
    name: "Switzerland",
    iso: "CH"
  },
  {
    name: "Taiwan",
    iso: "TW"
  },
  {
    name: "Thailand",
    iso: "TH"
  },
  {
    name: "Turkey",
    iso: "TR"
  },
  {
    name: "United Arab Emirates",
    iso: "AE"
  },
  {
    name: "United Kingdom",
    iso: "GB"
  },
  {
    name: "United States",
    iso: "US"
  },
  {
    name: "Uruguay",
    iso: "UY"
  },
  {
    name: "Vietnam",
    iso: "VN"
  },
  {
    name: "Virgin Islands (British)",
    iso: "VG"
  }
];

// src/geo/states/index.ts
var states_exports = {};
__export(states_exports, {
  AU: () => au_state_default,
  CA: () => ca_state_default,
  US: () => us_state_default
});

// src/geo/states/ca.state.ts
var ca_state_default = [
  {
    name: "Alberta",
    iso: "AB"
  },
  {
    name: "British Columbia",
    iso: "BC"
  },
  {
    name: "Manitoba",
    iso: "MB"
  },
  {
    name: "New Brunswick",
    iso: "NB"
  },
  {
    name: "Newfoundland and Labrador",
    iso: "NL"
  },
  {
    name: "Northwest Territories",
    iso: "NT"
  },
  {
    name: "Nova Scotia",
    iso: "NS"
  },
  {
    name: "Nunavut",
    iso: "NU"
  },
  {
    name: "Ontario",
    iso: "ON"
  },
  {
    name: "Prince Edward Island",
    iso: "PE"
  },
  {
    name: "Quebec",
    iso: "QC"
  },
  {
    name: "Saskatchewan",
    iso: "SK"
  },
  {
    name: "Yukon",
    iso: "YT"
  }
];

// src/geo/states/au.state.ts
var au_state_default = [
  { name: "New South Wales", iso: "AU-NSW" },
  { name: "Victoria", iso: "AU-VIC" },
  { name: "Queensland", iso: "AU-QLD" },
  { name: "Western Australia", iso: "AU-WA" },
  { name: "South Australia", iso: "AU-SA" },
  { name: "Tasmania", iso: "AU-TAS" },
  { name: "Australian Capital Territory", iso: "AU-ACT" },
  { name: "Northern Territory", iso: "AU-NT" },
  { name: "Norfolk Island", iso: "NF" },
  { name: "Christmas Island", iso: "CX" },
  { name: "Cocos (Keeling) Islands", iso: "CC" },
  { name: "Australian Antarctic Territory", iso: "AQ" },
  { name: "Heard Island and McDonald Islands", iso: "HM" }
];

// src/geo/states/us.state.ts
var us_state_default = [
  {
    name: "Alabama",
    iso: "AL"
  },
  {
    name: "Alaska",
    iso: "AK"
  },
  {
    name: "Arizona",
    iso: "AZ"
  },
  {
    name: "Arkansas",
    iso: "AR"
  },
  {
    name: "Armed Forces (AA)",
    iso: "AA"
  },
  {
    name: "Armed Forces (AE)",
    iso: "AE"
  },
  {
    name: "Armed Forces (AP)",
    iso: "AP"
  },
  {
    name: "California",
    iso: "CA"
  },
  {
    name: "Colorado",
    iso: "CO"
  },
  {
    name: "Connecticut",
    iso: "CT"
  },
  {
    name: "Delaware",
    iso: "DE"
  },
  {
    name: "District Of Columbia",
    iso: "DC"
  },
  {
    name: "Florida",
    iso: "FL"
  },
  {
    name: "Georgia",
    iso: "GA"
  },
  {
    name: "Guam",
    iso: "GU"
  },
  {
    name: "Hawaii",
    iso: "HI"
  },
  {
    name: "Idaho",
    iso: "ID"
  },
  {
    name: "Illinois",
    iso: "IL"
  },
  {
    name: "Indiana",
    iso: "IN"
  },
  {
    name: "Iowa",
    iso: "IA"
  },
  {
    name: "Kansas",
    iso: "KS"
  },
  {
    name: "Kentucky",
    iso: "KY"
  },
  {
    name: "Louisiana",
    iso: "LA"
  },
  {
    name: "Maine",
    iso: "ME"
  },
  {
    name: "Marshall Islands",
    iso: "MH"
  },
  {
    name: "Maryland",
    iso: "MD"
  },
  {
    name: "Massachusetts",
    iso: "MA"
  },
  {
    name: "Michigan",
    iso: "MI"
  },
  {
    name: "Minnesota",
    iso: "MN"
  },
  {
    name: "Mississippi",
    iso: "MS"
  },
  {
    name: "Missouri",
    iso: "MO"
  },
  {
    name: "Montana",
    iso: "MT"
  },
  {
    name: "Nebraska",
    iso: "NE"
  },
  {
    name: "Nevada",
    iso: "NV"
  },
  {
    name: "New Hampshire",
    iso: "NH"
  },
  {
    name: "New Jersey",
    iso: "NJ"
  },
  {
    name: "New Mexico",
    iso: "NM"
  },
  {
    name: "New York",
    iso: "NY"
  },
  {
    name: "North Carolina",
    iso: "NC"
  },
  {
    name: "North Dakota",
    iso: "ND"
  },
  {
    name: "Northern Mariana Islands",
    iso: "MP"
  },
  {
    name: "Ohio",
    iso: "OH"
  },
  {
    name: "Oklahoma",
    iso: "OK"
  },
  {
    name: "Oregon",
    iso: "OR"
  },
  {
    name: "Pennsylvania",
    iso: "PA"
  },
  {
    name: "Puerto Rico",
    iso: "PR"
  },
  {
    name: "Rhode Island",
    iso: "RI"
  },
  {
    name: "South Carolina",
    iso: "SC"
  },
  {
    name: "South Dakota",
    iso: "SD"
  },
  {
    name: "Tennessee",
    iso: "TN"
  },
  {
    name: "Texas",
    iso: "TX"
  },
  {
    name: "Utah",
    iso: "UT"
  },
  {
    name: "Vermont",
    iso: "VT"
  },
  {
    name: "Virgin Islands",
    iso: "VI"
  },
  {
    name: "Virginia",
    iso: "VA"
  },
  {
    name: "Washington",
    iso: "WA"
  },
  {
    name: "West Virginia",
    iso: "WV"
  },
  {
    name: "Wisconsin",
    iso: "WI"
  },
  {
    name: "Wyoming",
    iso: "WY"
  }
];

// src/geo/index.ts
function toList(data) {
  return data.map(({ name: label, iso: value }) => ({ label, value }));
}

// src/hooks/useArray.tsx
import { isFunction } from "@blurb/utils";
import React2 from "react";
var ArrayActions = class {
  constructor(set) {
    this.set = set;
  }
  /**
   * Clear array.
   *
   * ```ts
   * []
   * ```
   */
  clear() {
    return this.set([]);
  }
  /**
   * Clone array.
   *
   * ```ts
   * (array) => [...array]
   * ```
   */
  clone() {
    return this.set((array) => [...array]);
  }
  /**
   * Append to array.
   *
   * ```ts
   * (array) => [...array, value]
   * ```
   */
  add(value) {
    return this.set((array) => [...array, value]);
  }
  /**
   * Prepend to array.
   *
   * ```ts
   * (array) => [value, ...array]
   * ```
   */
  prepend(value) {
    return this.set((array) => [value, ...array]);
  }
  /**
   * Filter array.
   *
   * ```ts
   * (array) => array.filter(...args)
   * ```
   */
  filter(...args) {
    return this.set((array) => array.filter(...args));
  }
  /**
   * Remove by index.
   *
   * ```ts
   * this.filter((_, i) => i !== index)
   * ```
   */
  remove(index) {
    return this.filter((_, i) => i !== index);
  }
  /**
   * Map array.
   *
   * ```ts
   * (array) => array.map(...args)
   * ```
   */
  map(callbackfn, thisArg) {
    return this.set((array) => array.map(callbackfn, thisArg));
  }
  /**
     * Replace item at index.
     *
     * ```ts
     * this.map((v, i) => {
        if (i === index) {
          return isFunction(value) ? value(v) : value;
        }
  
        return v;
      })
     * ```
     */
  replace(index, value) {
    return this.map((v, i) => {
      if (i === index) {
        return isFunction(value) ? value(v) : value;
      }
      return v;
    });
  }
  /**
   * Map wrapper.
   *
   * ```ts
   * this.map((v, i, a) => {
      const result = callbackfn(v, i, a);
      return result ?? v;
    }, thisArg)
   * ```
   */
  update(callbackfn, thisArg) {
    return this.map((v, i, a) => {
      const result = callbackfn(v, i, a);
      return result != null ? result : v;
    }, thisArg);
  }
  /**
   * Insert in array.
   *
   * ```ts
   * (array) => [...array.slice(0, index), value, ...array.slice(index)]
   * ```
   */
  insert(index, value) {
    return this.set((array) => [
      ...array.slice(0, index),
      value,
      ...array.slice(index)
    ]);
  }
  /**
   * Creates a clone to modify.
   *
   * ```ts
   * (array) => {
      const copy = [...array];
      const result = callbackfn(copy);
      return result ?? copy;
    }
   * ```
   */
  modify(callbackfn) {
    return this.set((array) => {
      const copy = [...array];
      const result = callbackfn(copy);
      return result != null ? result : copy;
    });
  }
};
function useArray(initialArray, onChange) {
  const [array, setArray] = React2.useState(initialArray != null ? initialArray : []);
  const actions = React2.useMemo(() => new ArrayActions(setArray), [setArray]);
  React2.useEffect(() => {
    onChange && onChange(array);
  }, [array]);
  return [array, actions];
}

// src/hooks/useClipboard.tsx
import { useState } from "react";
function useClipboard({ timeout = 2e3 } = {}) {
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);
  const [copyTimeout, setCopyTimeout] = useState(null);
  const handleCopyResult = (value) => {
    window.clearTimeout(copyTimeout);
    setCopyTimeout(window.setTimeout(() => setCopied(false), timeout));
    setCopied(value);
  };
  const copy = (valueToCopy) => {
    if ("clipboard" in navigator) {
      navigator.clipboard.writeText(valueToCopy).then(() => handleCopyResult(true)).catch((err) => setError(err));
    } else {
      setError(new Error("useClipboard: navigator.clipboard is not supported"));
    }
  };
  const reset = () => {
    setCopied(false);
    setError(null);
    window.clearTimeout(copyTimeout);
  };
  return { copy, reset, error, copied };
}

// src/hooks/useDebounce.tsx
import { useEffect, useState as useState2, useRef } from "react";
function useDebounce(value, wait, options = { leading: false }) {
  const [_value, setValue] = useState2(value);
  const mountedRef = useRef(false);
  const timeoutRef = useRef(null);
  const cooldownRef = useRef(false);
  const cancel = () => window.clearTimeout(timeoutRef.current);
  useEffect(() => {
    if (mountedRef.current) {
      if (!cooldownRef.current && options.leading) {
        cooldownRef.current = true;
        setValue(value);
      } else {
        cancel();
        timeoutRef.current = window.setTimeout(() => {
          cooldownRef.current = false;
          setValue(value);
        }, wait);
      }
    }
  }, [value, options.leading, wait]);
  useEffect(() => {
    mountedRef.current = true;
    return cancel;
  }, []);
  return [_value, cancel];
}
function useDebounceCallback(value, wait, callback, options = { leading: false }) {
  const mountedRef = useRef(false);
  const timeoutRef = useRef(null);
  const cooldownRef = useRef(false);
  const cancel = () => window.clearTimeout(timeoutRef.current);
  useEffect(() => {
    if (mountedRef.current) {
      if (!cooldownRef.current && options.leading) {
        cooldownRef.current = true;
        callback(value);
      } else {
        cancel();
        timeoutRef.current = window.setTimeout(() => {
          cooldownRef.current = false;
          callback(value);
        }, wait);
      }
    }
  }, [value, options.leading, wait]);
  useEffect(() => {
    mountedRef.current = true;
    return cancel;
  }, []);
  return [cancel];
}

// src/hooks/useMergeRefs.tsx
import React3 from "react";
function assignRef(ref, value) {
  if (ref == null) return;
  if (typeof ref === "function") {
    ref(value);
    return;
  }
  try {
    ref.current = value;
  } catch (error) {
    throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
  }
}
function mergeRefs(...refs) {
  return (node) => {
    refs.forEach((ref) => {
      assignRef(ref, node);
    });
  };
}
function useMergeRefs(...refs) {
  return React3.useMemo(() => mergeRefs(...refs), refs);
}

// src/hooks/useObjectState.tsx
import { isFunction as isFunction2 } from "@blurb/utils";
import React4 from "react";
function useObjectState(defaultValues) {
  const [values, setValues] = React4.useState(defaultValues);
  const setValue = React4.useCallback(function(key, value) {
    setValues((values2) => __spreadProps(__spreadValues({}, values2), {
      [key]: isFunction2(value) ? value(values2[key]) : value
    }));
  }, []);
  return [values, setValue, setValues];
}

// src/hooks/useSimplePagination.tsx
import React5 from "react";
function useSimplePagination(initialPages) {
  const [page, setPage] = React5.useState(0);
  const [pages, setPages] = React5.useState(initialPages < 0 ? 0 : initialPages);
  const handleSetPage = React5.useCallback(
    (page2) => {
      if (page2 < 0) return setPage(0);
      if (page2 >= pages) return setPage(pages === 0 ? 0 : pages - 1);
      return setPage(page2);
    },
    [pages]
  );
  const handleSetPages = React5.useCallback(
    (pages2) => {
      if (pages2 < 0) setPages(0);
      else setPages(pages2);
      handleSetPage(page);
    },
    [handleSetPage, page]
  );
  React5.useEffect(() => {
    handleSetPages(initialPages);
  }, [initialPages]);
  return {
    page,
    pages,
    setPages: handleSetPages,
    setPage: handleSetPage,
    nextPage: () => handleSetPage(page + 1),
    previousPage: () => handleSetPage(page - 1)
  };
}

// src/hooks/useToggle.tsx
import { isUndefined } from "@blurb/utils";
import React6 from "react";
function useToggle(initial) {
  const [internal, setInternal] = React6.useState(Boolean(initial));
  const toggle = React6.useCallback(
    (value) => {
      setInternal((i) => isUndefined(value) ? !i : value);
    },
    [setInternal]
  );
  return [internal, toggle];
}

// src/pdf-preview/index.ts
var pdf_preview_exports = {};
__export(pdf_preview_exports, {
  useCoverPreview: () => useCoverPreview,
  useGutsPages: () => useGutsPages,
  useGutsPreview: () => useGutsPreview
});

// src/pdf-preview/helpers.ts
import { objectsSum } from "@blurb/utils";
function getCoverDataFromProjectPreview(collection) {
  const imageUrl = collection.previews.cover.outside_full_cover.preview_fixed;
  const dimensions = {
    width: collection.previews.definitions.cover.main_content_pre_trim.width,
    height: collection.previews.definitions.cover.main_content_pre_trim.height
  };
  const bleed = collection.inline_product.specification.cover_spec.bleeds;
  const safeZone = objectsSum(
    bleed,
    collection.inline_product.specification.cover_spec.safe_zone
  );
  const definitions = collection.previews.definitions.cover;
  const sections = Object.keys(definitions).filter(
    (key) => {
      var _a;
      return definitions[key] && !((_a = definitions[key]) == null ? void 0 : _a.empty);
    }
  ).reduce(
    (previous, key) => {
      const section = definitions[key];
      previous[key] = {
        top: section.top,
        bottom: section.bottom,
        left: section.left,
        right: section.right
      };
      return previous;
    },
    {}
  );
  return {
    imageUrl,
    dimensions,
    bleed,
    safeZone,
    sections
  };
}
function getGutsDataFromProjectPreview(projectPreview) {
  const definitions = projectPreview.previews.definitions.pages;
  const pagesSpec = projectPreview.inline_product.specification.pages_spec;
  const previewsPages = projectPreview.previews.pages;
  const dimensions = {
    even: {
      top: 0,
      left: 0,
      width: definitions.even_page_content.width,
      height: definitions.even_page_content.height
    },
    odd: {
      top: 0,
      left: definitions.even_page_content.width,
      width: definitions.odd_page_content.width,
      height: definitions.odd_page_content.height
    }
  };
  const bleed = pagesSpec.bleeds;
  const safeZone = objectsSum(pagesSpec.bleeds, pagesSpec.safe_zone);
  const pages = [];
  let group = Array(2).fill(void 0);
  for (let i = 0; i < previewsPages.length; i++) {
    const page = previewsPages[i];
    group[page.type === "even" ? 0 : 1] = {
      type: page.type,
      imageUrl: page.previews.preview_fixed,
      thumbnailUrl: page.previews.thumbnail_fixed
    };
    if (page.type === "odd" || i >= previewsPages.length - 1) {
      pages.push(group);
      group = Array(2).fill(void 0);
    }
  }
  return {
    dimensions,
    bleed,
    safeZone,
    pages
  };
}

// src/pdf-preview/useCoverPreview.tsx
import { PdfCoverPreviewWorker } from "@blurb/pdf-preview";
import React7 from "react";
var allSections = [
  {
    key: "left_flap_content",
    name: "Left Flap"
  },
  {
    key: "left_main_content",
    name: "Left Main Content"
  },
  {
    key: "isbn_placeholder",
    name: "ISBN Placeholder"
  },
  {
    key: "spine_content",
    name: "Spine Content"
  },
  {
    key: "right_main_content",
    name: "Right Main Content"
  },
  {
    key: "right_flap_content",
    name: "Right Flap Content"
  }
];
function useCoverPreview(projectPreview) {
  const [worker, setWorker] = React7.useState();
  const [settings, setSettings, overrideSettings] = useObjectState({});
  const [sections, setSections] = React7.useState([]);
  const [highlight, setHighlight] = React7.useState();
  const ref = React7.useRef(null);
  React7.useEffect(() => {
    const coverData = getCoverDataFromProjectPreview(projectPreview);
    PdfCoverPreviewWorker.init(ref.current, coverData).then((worker2) => {
      setWorker(worker2);
      overrideSettings(worker2.settings);
      setSections(
        allSections.filter(({ key }) => key in worker2.data.sections).map((section) => {
          const workerSection = worker2.data.sections[section.key];
          return __spreadProps(__spreadValues({}, section), {
            dimensions: {
              width: workerSection.right - workerSection.left,
              height: workerSection.bottom - workerSection.top
            }
          });
        })
      );
    }).catch((error) => {
      console.error("Failed to create PdfCoverPreviewWorker", error);
    });
  }, [projectPreview]);
  React7.useEffect(() => {
    if (!worker) return;
    worker.settings = settings;
    worker.render(highlight);
  }, [worker, highlight, settings]);
  return {
    ref,
    worker,
    sections,
    settings,
    setSettings,
    highlight,
    setHighlight
  };
}

// src/pdf-preview/useGutsPages.tsx
import React8 from "react";
function useGutsPages(page, pages) {
  const paginationPages = React8.useMemo(
    () => Math.ceil(pages.length / 5),
    [pages]
  );
  const pagination = useSimplePagination(paginationPages);
  const buttons = React8.useMemo(() => {
    const buttonPages = [];
    for (let i = 0; i < 5; i++) {
      const index = pagination.page * 5 + i;
      const page2 = pages[index];
      if (page2) {
        const [first, second] = page2;
        const name = [];
        if (first) name.push(index * 2);
        if (first && second) name.push("-");
        if (second) name.push(index * 2 + 1);
        buttonPages.push({
          page: page2,
          index,
          name: name.join(" ")
        });
      }
    }
    return buttonPages;
  }, [pagination, pages]);
  const indexes = React8.useMemo(() => {
    const [first, second] = pages[page] || [];
    return {
      first: first ? page * 2 : void 0,
      second: second ? page * 2 + 1 : void 0
    };
  }, [pages, page]);
  return { pagination, buttons, indexes };
}

// src/pdf-preview/useGutsPreview.tsx
import {
  PdfGutsPreviewWorker
} from "@blurb/pdf-preview";
import React9 from "react";
function useGutsPreview(projectPreview) {
  const [worker, setWorker] = React9.useState();
  const [settings, setSettings, overrideSettings] = useObjectState({});
  const [pages, setPages] = React9.useState([]);
  const [page, setPage] = React9.useState(0);
  const ref = React9.useRef(null);
  const handleSetPage = React9.useCallback(
    (page2) => {
      let validPage = page2;
      if (page2 < 0) validPage = 0;
      else if (page2 >= pages.length) validPage = pages.length - 1;
      setPage(validPage);
    },
    [pages]
  );
  React9.useEffect(() => {
    const gutsData = getGutsDataFromProjectPreview(projectPreview);
    PdfGutsPreviewWorker.init(ref.current, gutsData).then((worker2) => {
      setWorker(worker2);
      overrideSettings(worker2.settings);
      setPages(worker2.data.pages);
    }).catch((error) => {
      console.error("Failed to create PdfGutsPreviewWorker", error);
    });
  }, [projectPreview]);
  React9.useEffect(() => {
    if (!worker) return;
    worker.settings = settings;
    worker.render(page);
  }, [worker, page, settings]);
  return {
    ref,
    worker,
    settings,
    setSettings,
    page,
    pages,
    setPage: handleSetPage
  };
}

// src/task/EventEmitter.ts
var EventEmitter = class {
  constructor() {
    this._events = {};
  }
  /**
   * Registers event listener for a specific event type.
   *
   * @template TType - Event type.
   * @param type - The event type to listen for.
   * @param listener - Event listener function to register.
   * @returns - EventEmitter instance, for method chaining.
   */
  on(type, listener) {
    if (!(type in this._events)) {
      this._events[type] = [];
    }
    this._events[type].push(listener);
    return this;
  }
  /**
   * Removes a registered event listener for a specific event type.
   *
   * @template TType - Event type.
   * @param type - The event type to remove the listener from.
   * @param listener - Event listener function to remove.
   * @return - EventEmitter instance, for method chaining.
   */
  off(type, listener) {
    if (this._events[type] !== void 0) {
      this._events[type] = this._events[type].filter(
        (savedListener) => savedListener !== listener
      );
    }
    return this;
  }
  /**
   * Emits an event of a specific type, calling all registered listeners for that event type.
   *
   * @template TType - Event type.
   * @param type - The event type to emit.
   * @param data - Data associated with the event.
   * @return - EventEmitter instance, for method chaining.
   */
  emit(type, ...data) {
    var _a;
    (_a = this._events[type]) == null ? void 0 : _a.forEach((listener) => listener.apply(this, data));
    return this;
  }
};

// src/task/Optional.ts
var OptionalValue = class _OptionalValue {
  /**
   * Creates an instance of `OptionalValue`.
   * @param value - the type of the value
   */
  constructor(value) {
    this.value = value;
  }
  /**
   * Returns true if there is a value present, otherwise false.
   */
  static isPresent(value) {
    return value !== void 0 && value !== null;
  }
  /**
   * Returns an empty `OptionalValue` instance. No value is present for this `OptionalValue`.
   */
  static empty() {
    return new _OptionalValue(null);
  }
  /**
   * Returns an `OptionalValue` describing the specified value, if non-null,
   * otherwise returns an empty `OptionalValue`.
   *
   * @template T - the type of the value
   * @param value - the possibly-null value to describe
   */
  static of(value) {
    if (_OptionalValue.isPresent(value)) {
      return new _OptionalValue(value);
    }
    return _OptionalValue.empty();
  }
  /**
   * Returns value held by this `OptionalValue`.
   */
  get() {
    return this.value;
  }
  /**
   * Returns true if there is a value present, otherwise false.
   */
  isPresent() {
    return _OptionalValue.isPresent(this.value);
  }
  /**
   * If a value is present, invoke the specified consumer with the value, otherwise do nothing.
   *
   * @param consumer - callback to be executed if a value is present
   */
  ifPresent(consumer) {
    if (this.isPresent()) {
      consumer(this.value);
    }
    return this;
  }
  /**
   * Returns true if there is a no value present, otherwise false.
   */
  isEmpty() {
    return !_OptionalValue.isPresent(this.value);
  }
  /**
   * If a value is not present, invoke the specified consumer, otherwise do nothing.
   *
   * @param consumer - callback to be executed if a value is not present
   */
  ifEmpty(consumer) {
    if (this.isEmpty()) {
      consumer();
    }
    return this;
  }
  /**
   * If a value is present, and the value matches the given predicate,
   * return an `OptionalValue` describing the value, otherwise return an empty `OptionalValue`.
   *
   * @template U - the type of the value
   * @param predicate - a predicate to apply to the value, if present
   */
  filter(predicate) {
    if (this.isEmpty()) {
      return this;
    }
    if (predicate(this.value)) {
      return this;
    }
    return _OptionalValue.empty();
  }
  /**
   * If a value is present, apply the provided mapping function to it, and if the result is non-null,
   * return an `OptionalValue` describing the result. Otherwise return an empty `OptionalValue`.
   *
   * @template U - the type of the value
   * @template V - the type of the result of the mapping function
   * @param mapper - a mapping function to apply to the value, if present
   */
  map(mapper) {
    if (this.isEmpty()) {
      return this;
    }
    const mapped = mapper(this.value);
    if (_OptionalValue.isPresent(mapped)) {
      return _OptionalValue.of(mapped);
    }
    return _OptionalValue.empty();
  }
  /**
   * If a value is present, apply the provided `OptionalValue`-bearing mapping function to it,
   * return that result, otherwise return an empty `OptionalValue`.
   * This method is similar to `map` method, but the provided mapper is one whose result is already an `OptionalValue`,
   * and if invoked, `flatMap` does not wrap it with an additional `OptionalValue`.
   *
   * @template U - the type of the value
   * @template V - the type parameter to the `OptionalValue` returned by
   * @param mapper - a mapping function to apply to the value, if present the mapping function
   */
  flatMap(mapper) {
    if (this.isEmpty()) {
      return this;
    }
    return mapper(this.value);
  }
  /**
   * Returns the value if present, otherwise return other.
   *
   * @template U - the type of the value
   * @param other - the value to be returned if there is no value present
   */
  orElse(other) {
    if (this.isPresent()) {
      return this.value;
    }
    return other;
  }
  /**
   * Returns the value if present, otherwise invokes other and returns the result of that invocation.
   *
   * @template U - the type of the value
   * @param other - a callback whose result is returned if no value is present
   */
  orElseGet(other) {
    if (this.isPresent()) {
      return this.value;
    }
    return other();
  }
  /**
   * Returns the contained value, if present, otherwise throws an `Error` created by the provided supplier.
   *
   * @template E - type of the `Error` to be thrown
   * @param errorSupplier - the supplier which will return the `Error` to be thrown
   */
  orElseThrow(errorSupplier) {
    if (this.isPresent()) {
      return this.value;
    }
    throw errorSupplier();
  }
};
var Optional = OptionalValue.of;
Optional.empty = OptionalValue.empty;

// src/task/Task.ts
var TaskBase = class extends EventEmitter {
  constructor() {
    super(...arguments);
    // Status
    /**
     * Current status.
     */
    this._status = "idle";
    // Progress
    /**
     * Current progress of the task ([0, 1]).
     */
    this._progress = 0;
    // Result
    /**
     * The result of the task, encapsulated in an Optional object.
     */
    this._result = Optional.empty();
  }
  /**
   * Current status.
   */
  get status() {
    return this._status;
  }
  /**
   * Set the status.
   *
   * @emits change
   */
  set status(status) {
    if (status !== this.status) {
      this._status = status;
      this.emit("change");
    }
  }
  /**
   * Sets the status.
   *
   * @param status - The status to set.
   * @returns The instance of the task.
   */
  setStatus(status) {
    this.status = status;
    return this;
  }
  /**
   * Current progress of the task ([0, 1]).
   */
  get progress() {
    return this._progress;
  }
  /**
   * Sets the progress.
   *
   * @emits progress
   * @emits change
   */
  set progress(progress) {
    const validProgress = progress > 1 ? 1 : progress < 0 ? 0 : progress;
    if (validProgress !== this._progress) {
      this._progress = validProgress;
      this.emit("progress", validProgress).emit("change");
    }
  }
  /**
   * Sets the progress.
   *
   * @param progress - The progress to set.
   * @returns The instance of the task.
   */
  setProgress(progress) {
    this.progress = progress;
    return this;
  }
  /**
   * The list of errors encountered during the task's execution.
   */
  get errors() {
    return this._errors;
  }
  /**
   * Set the list of errors.
   *
   * @param errors - Array of errors to set.
   * @emits change
   */
  set errors(errors) {
    this._errors = errors;
    this.emit("change");
  }
  /**
   * Adds one or more errors to the task and changes its status to 'error'.
   *
   * @param errors - The errors to add to the task.
   * @returns The instance of the task.
   * @emits change
   */
  addError(...errors) {
    if (errors.length) {
      if (!this.errors) this._errors = [];
      this._errors.push(...errors);
      this._status = "error";
      this.emit("change");
    }
    return this;
  }
  /**
   * The list of warnings generated during the task's execution.
   */
  get warnings() {
    return this._warnings;
  }
  /**
   * Set the list of warnings.
   *
   * @param warnings - Array of warnings to set.
   * @emits change
   */
  set warnings(warnings) {
    this._warnings = warnings;
    this.emit("change");
  }
  /**
   * Adds one or more warnings to the task.
   *
   * @param warnings The warnings to add to the task.
   * @returns The instance of the task.
   * @emits change
   */
  addWarning(...warnings) {
    if (warnings.length) {
      if (!this._warnings) this._warnings = [];
      this._warnings.push(...warnings);
      this.emit("change");
    }
    return this;
  }
  /**
   * The result of the task, encapsulated in an Optional object.
   */
  get result() {
    return this._result;
  }
  /**
   * Setter for the task's result. Changes the task's status to 'success' and progress to 1.
   *
   * @param result The result to set for the task.
   * @emits progress
   * @emits change
   */
  set result(result) {
    this._result = result;
    this._status = "success";
    this._progress = 1;
    this.emit("progress", this.progress).emit("change");
  }
  /**
   * Sets the result of the task.
   *
   * @param result The result to set for the task.
   * @returns The instance of the task.
   */
  setResult(result) {
    this.result = result;
    return this;
  }
};
var Task = class _Task extends TaskBase {
  /**
   * Creates an instance of Task.
   *
   * @param builder - Task builder function used to create new instances of the task.
   * @param name - Name of the task.
   * @param _config - Configuration object for the task.
   * @param data - Data required to execute the task.
   */
  constructor(builder, name, _config, data) {
    super();
    this.builder = builder;
    this.name = name;
    this._config = _config;
    this.data = data;
    this.id = createTaskId(name);
  }
  /**
   * Binds the task to a `TaskManager`.
   *
   * @param manager - `TaskManager` to bind this task to.
   */
  bind(manager) {
    this._manager = manager;
  }
  /**
   * Gets the `TaskManager` to which this task is bound.
   *
   * @returns The associated TaskManager.
   * @throws If the task is not bound to a TaskManager.
   */
  get manager() {
    if (!this._manager) {
      throw new Error(
        `Missing TaskManager. Please use ${_Task.name}.${this.bind.name}(TaskManager).`
      );
    }
    return this._manager;
  }
  /**
   * Executes the task. Changes the task's status and handles the task's result or error.
   *
   * @returns Result of the task execution.
   * @throws If the task is not in the "idle" state or if the task execution fails.
   */
  execute() {
    return __async(this, null, function* () {
      if (this.status !== "idle") {
        throw new Error('Task is not in "idle" state.');
      }
      this.setStatus("in-progress");
      try {
        const result = yield Promise.resolve(
          this._config.execute.bind(this)(this.data)
        );
        this.result = Optional(result);
      } catch (error) {
        if (Array.isArray(error)) {
          this.addError(...error);
        } else {
          this.addError(error);
        }
        throw error;
      }
    });
  }
  /**
   * Parses the task, providing a representation suitable for UI rendering.
   *
   * @returns The parsed representation of the task.
   */
  parse() {
    var _a, _b, _c;
    const parsed = (_b = (_a = this._config.parse) == null ? void 0 : _a.bind(this)()) != null ? _b : {};
    return __spreadValues({
      title: `${this.name} - ${this.status}`,
      warnings: this.warnings,
      errors: (_c = this.errors) == null ? void 0 : _c.map((error) => {
        if (error instanceof Error) {
          return error.message;
        }
        return String(error);
      }),
      result: this.result.isPresent() ? `${this.result.get()}` : void 0
    }, parsed);
  }
  /**
   * Returns a string representation of the Task instance.
   *
   * @returns A string representing the task.
   */
  toString() {
    return `${_Task.name} { name: ${JSON.stringify(this.name)}, id: #${this.id} }`;
  }
  /**
   * Creates a clone of the current task.
   *
   * @returns A new `Task` instance with the same configuration and data.
   */
  clone() {
    return this.builder(this.data);
  }
};
function createTaskId(name) {
  const randomHex = Math.floor(Math.random() * Date.now() * name.length).toString(16).padEnd(12, "0");
  const nameHex = [...name].map((c) => c.charCodeAt(0).toString(16)).join("");
  const timeHex = Date.now().toString(16).padStart(12, "0");
  return `${randomHex}-${nameHex}-${timeHex}`;
}
function isTask(task, taskBuilder) {
  return task instanceof Task && task.builder.id === taskBuilder.id;
}
function createTask(_a) {
  var _b = _a, {
    name
  } = _b, config = __objRest(_b, [
    "name"
  ]);
  const builder = function(data) {
    return new Task(builder, name, config, data);
  };
  builder.id = createTaskId(name);
  builder.taskName = name;
  builder.toString = function() {
    return `TaskBuilder { name: ${JSON.stringify(this.taskName)}, id: #${this.id} }`;
  };
  return builder;
}

// src/task/TaskManager.ts
var TaskManagerBase = class extends EventEmitter {
  constructor() {
    super(...arguments);
    // Status
    /**
     * Current status.
     */
    this._status = "idle";
    // Progress
    /**
     * Current progress of tasks ([0, 1]).
     */
    this._progress = 0;
    // Flags
    /**
     * Current flags.
     */
    this._flags = /* @__PURE__ */ new Set([
      TaskManager.Flag.FAIL_ON_ERROR
    ]);
    // Queue
    /**
     * Current queue of tasks.
     */
    this._queue = [];
    // Tasks
    /**
     * Current list of executed tasks.
     */
    this._tasks = [];
  }
  /**
   * Current status.
   */
  get status() {
    return this._status;
  }
  /**
   * Sets the status.
   *
   * @emits change
   */
  set status(status) {
    if (status !== this.status) {
      this._status = status;
      this.emit("change");
    }
  }
  /**
   * Sets the status.
   *
   * @param status - The status to set.
   * @returns The instance of the manager.
   */
  setStatus(status) {
    this.status = status;
    return this;
  }
  /**
   * Checks if the status matches any of the provided statuses.
   *
   * @param statuses - Array of statuses to check against.
   * @returns True if the current status is among the provided statuses, false otherwise.
   */
  isStatus(...statuses) {
    return statuses.includes(this.status);
  }
  /**
   * Current progress of tasks ([0, 1]).
   */
  get progress() {
    return this._progress;
  }
  /**
   * Sets the progress of tasks.
   *
   * @emits progress
   * @emits change
   */
  set progress(progress) {
    const validProgress = progress > 1 ? 1 : progress < 0 ? 0 : progress;
    if (validProgress !== this.progress) {
      this._progress = validProgress;
      this.emit("progress", this.progress).emit("change");
    }
  }
  /**
   * Sets the progress of tasks.
   *
   * @param progress - The progress to set.
   * @returns The instance of the manager.
   */
  setProgress(progress) {
    this.progress = progress;
    return this;
  }
  /**
   * Gets the current array of flags.
   */
  get flags() {
    return Array.from(this._flags);
  }
  /**
   * Sets the flags.
   *
   * @emits change
   */
  set flags(flags) {
    this._flags = flags;
    this.emit("change");
  }
  /**
   * Sets the flags.
   *
   * @param flags - The flags to set.
   * @returns The instance of the manager.
   */
  setFlags(flags) {
    this.flags = flags;
    return this;
  }
  /**
   * Adds a flag.
   *
   * @param flag - The flag to add.
   * @returns The instance of the manager.
   *
   * @emits change
   */
  addFlag(flag) {
    this._flags.add(flag);
    this.emit("change");
    return this;
  }
  /**
   * Removes a flag.
   *
   * @param flag - The flag to add.
   * @returns The instance of the manager.
   * @emits change
   */
  removeFlag(flag) {
    this._flags.delete(flag);
    this.emit("change");
    return this;
  }
  /**
   * Checks if a given flag is set.
   *
   * @param flag - The flag to check.
   * @returns True if the flag is set, false otherwise.
   */
  hasFlag(flag) {
    return this._flags.has(flag);
  }
  /**
   * Checks if the given flags is set.
   *
   * @param flags - The flags to check.
   * @returns - True if all flags are set, false otherwise.
   */
  hasFlags(...flags) {
    return flags.every((flag) => this.hasFlag(flag));
  }
  /**
   * Current queue of tasks.
   */
  get queue() {
    return this._queue;
  }
  /**
   * Sets the task queue.
   */
  set queue(queue) {
    this._queue = queue;
  }
  /**
   * Current list of executed tasks.
   */
  get tasks() {
    return this._tasks;
  }
  /**
   * Sets the list of executed tasks.
   *
   * @param tasks - The list of tasks to set.
   */
  set tasks(tasks) {
    this._tasks = tasks;
  }
};
var TaskManager = class _TaskManager extends TaskManagerBase {
  /**
   * Adds an array of tasks to the task queue.
   *
   * @param tasks - An array of tasks to add to the queue.
   * @returns The instance of the manager.
   * @emits change
   */
  addTasks(tasks) {
    this.queue.push(
      ...tasks.map((task) => {
        task.bind(this);
        return task;
      })
    );
    this.emit("change");
    return this;
  }
  /**
   * Calculates the overall progress of the tasks.
   *
   * @returns The calculated progress.
   */
  calculateProgress() {
    const tasksProgress = this.tasks.reduce(
      (progress, task) => progress + task.progress,
      0
    );
    return tasksProgress / (this.queue.length + this.tasks.length);
  }
  /**
   * Executes tasks in a linear sequence.
   *
   * @returns A promise that resolves when all tasks in the queue have been executed linearly.
   */
  executeLinear() {
    return __async(this, null, function* () {
      const task = this.queue.shift();
      if (!task) return;
      this.tasks.push(task);
      this.emit("task", task).emit("change");
      task.on("progress", () => {
        this.setProgress(this.calculateProgress());
      });
      return yield task.execute();
    });
  }
  /**
   * Executes tasks in parallel.
   *
   * @returns A promise that resolves when all tasks in the queue have been executed in parallel.
   */
  executeParallel() {
    return __async(this, null, function* () {
      const queueTasks = [...this.queue];
      this.clearQueue();
      this.tasks.push(...queueTasks);
      const executeTasks = () => {
        return queueTasks.map((task) => __async(this, null, function* () {
          this.emit("task", task).emit("change");
          task.on("progress", () => {
            this.setProgress(this.calculateProgress());
          });
          try {
            yield task.execute();
          } catch (error) {
            throw { task, error };
          }
        }));
      };
      if (this.hasFlag(_TaskManager.Flag.FAIL_ON_ERROR)) {
        return yield Promise.all(executeTasks());
      }
      return yield Promise.allSettled(executeTasks());
    });
  }
  /**
   * Start task manager.
   * @param {boolean} [force] - Force start if in "fail" status.
   */
  /**
   * Starts the execution of tasks in the task manager.
   *
   * @param force - Force start even if in "fail" status.
   * @returns A promise that resolves when task execution starts.
   */
  start(force) {
    return __async(this, null, function* () {
      if (!this.queue.length) {
        return console.warn(`${_TaskManager.name} empty queue.`);
      }
      if (!this.isStatus("idle", "stopped") && !(force && this.isStatus("fail"))) {
        switch (this.status) {
          case "fail":
            return console.warn(`${_TaskManager.name} failed.`);
          case "success":
            return console.warn(`${_TaskManager.name} succeeded.`);
          default:
            return console.warn(`${_TaskManager.name} is already in progress.`);
        }
      }
      if (this.hasFlag(_TaskManager.Flag.STOP)) {
        this.removeFlag(_TaskManager.Flag.STOP);
      }
      this.setStatus("in-progress");
      while (this.queue.length > 0) {
        try {
          if (this.hasFlag(_TaskManager.Flag.PARALLEL_EXECUTION)) {
            yield this.executeParallel();
          } else {
            yield this.executeLinear();
          }
        } catch (error) {
          this.emit("error");
          if (this.hasFlag(_TaskManager.Flag.FAIL_ON_ERROR)) {
            return this.setStatus("fail").emit("fail", error);
          }
        }
        if (this.hasFlag(_TaskManager.Flag.STOP)) {
          return this.removeFlag(_TaskManager.Flag.STOP).setStatus("stopped");
        }
      }
      return this.setStatus("success");
    });
  }
  /**
   * Stops the execution of tasks in the task manager.
   */
  stop() {
    if (!this.isStatus("in-progress")) {
      return console.warn(`${_TaskManager.name} is not in-progress.`);
    }
    this.addFlag(_TaskManager.Flag.STOP);
  }
  /**
   * Resets the task manager to its initial state.
   */
  reset() {
    if (this.isStatus("in-progress")) {
      return console.warn(`${_TaskManager.name} is in-progress.`);
    }
    if (this.isStatus("idle")) {
      return console.warn(`${_TaskManager.name} is already idle.`);
    }
    const tmp = [...this.tasks, ...this.queue];
    this.queue = [];
    this.tasks = [];
    this.status = "idle";
    this.progress = 0;
    this.emit("progress", this.progress);
    this.addTasks(tmp.map((task) => task.clone()));
  }
  /**
   * Clears the task queue.
   * @returns The instance of the manager.
   */
  clearQueue() {
    this.queue = [];
    this.emit("change");
    return this;
  }
  /**
   * Finds a task in the list of tasks.
   *
   * @param taskBuilder - The builder of the task to find.
   * @returns The found task or undefined.
   */
  findTask(taskBuilder) {
    for (let i = 0; i < this.tasks.length; i++) {
      const task = this.tasks[i];
      if (isTask(task, taskBuilder)) {
        return task;
      }
    }
  }
  /**
   * Retrieves a task from the list of tasks.
   *
   * @param taskBuilder - The builder of the task to retrieve.
   * @returns The retrieved task.
   * @throws If the task is not found.
   */
  getTask(taskBuilder) {
    const task = this.findTask(taskBuilder);
    if (!task) {
      throw new Error(`Task by ${taskBuilder} not found.`);
    }
    return task;
  }
  /**
   * Retrieves the result of a task.
   *
   * @param taskBuilder - The builder of the task whose result to retrieve.
   * @returns The result of the task.
   * @throws If the task is not found or if the result is empty.
   */
  getTaskResult(taskBuilder) {
    const task = this.getTask(taskBuilder);
    if (task.result.isEmpty()) {
      throw new Error(`${task} result is empty.`);
    }
    return task.result.get();
  }
  /**
   * Finds the last task of a specific type in the list of tasks.
   *
   * @param taskBuilder - The builder of the task to find.
   * @returns The found task or undefined.
   */
  findLastTask(taskBuilder) {
    for (let i = this.tasks.length - 1; i >= 0; i--) {
      const task = this.tasks[i];
      if (isTask(task, taskBuilder)) {
        return task;
      }
    }
  }
  /**
   * Retrieves the last task of a specific type from the list of tasks.
   *
   * @param taskBuilder - The builder of the task to retrieve.
   * @returns The retrieved task.
   * @throws If the task is not found.
   */
  getLastTask(taskBuilder) {
    const task = this.findLastTask(taskBuilder);
    if (!task) {
      throw new Error(`Task by ${taskBuilder} not found.`);
    }
    return task;
  }
  /**
   * Retrieves the result of the last task of a specific type.
   *
   * @param taskBuilder - The builder of the task whose result to retrieve.
   * @returns The result of the task.
   * @throws If the task is not found or if the result is empty.
   */
  getLastTaskResult(taskBuilder) {
    const task = this.getLastTask(taskBuilder);
    if (task.result.isEmpty()) {
      throw new Error(`${task} result is empty.`);
    }
    return task.result.get();
  }
  /**
   * Finds all tasks of a specific type in the list of tasks.
   *
   * @param taskBuilder - The builder of the task type to find.
   * @returns Array of found tasks.
   */
  findTasks(taskBuilder) {
    return this.tasks.filter((task) => isTask(task, taskBuilder));
  }
  /**
   * Retrieves the results of all tasks of a specific type.
   *
   * @param taskBuilder - The builder of the task type whose results to retrieve.
   * @returns Array of results.
   * @throws If any of the task results is empty.
   */
  getTasksResults(taskBuilder) {
    const results = [];
    for (let i = 0; i < this.tasks.length; i++) {
      const task = this.tasks[i];
      if (isTask(task, taskBuilder)) {
        if (task.result.isEmpty()) {
          throw new Error(`${task} result is empty.`);
        }
        results.push(task.result.get());
      }
    }
    return results;
  }
};
((TaskManager2) => {
  let Flag;
  ((Flag2) => {
    Flag2["STOP"] = "STOP";
    Flag2["FAIL_ON_ERROR"] = "FAIL_ON_ERROR";
    Flag2["PARALLEL_EXECUTION"] = "PARALLEL_EXECUTION";
  })(Flag = TaskManager2.Flag || (TaskManager2.Flag = {}));
})(TaskManager || (TaskManager = {}));

// src/utils/index.ts
var utils_exports = {};
__export(utils_exports, {
  Byte: () => Byte,
  Megabyte: () => Megabyte,
  Pt: () => Pt,
  capitalize: () => capitalize,
  countryIsoToName: () => countryIsoToName,
  countryList: () => countryList,
  createPublicUrl: () => createPublicUrl,
  disableEnterKeyPress: () => disableEnterKeyPress,
  firstKeyAndValue: () => firstKeyAndValue,
  firstKeyValue: () => firstKeyValue,
  formatCount: () => formatCount,
  formatCurrency: () => formatCurrency,
  formatDimensions: () => formatDimensions,
  formatInDimensions: () => formatInDimensions,
  getCurrencyFormatter: () => getCurrencyFormatter,
  groupBy: () => groupBy,
  handleBodyScrollbar: () => handleBodyScrollbar,
  isEmptyObject: () => isEmptyObject,
  isSameObject: () => isSameObject,
  isUndefinedAll: () => isUndefinedAll,
  isValidRegex: () => isValidRegex,
  parseErrorMessage: () => parseErrorMessage,
  rootPath: () => rootPath,
  stateIsoToName: () => stateIsoToName,
  unitedStatesStates: () => unitedStatesStates
});

// src/utils/array.util.ts
import { isFunction as isFunction3 } from "@blurb/utils";
function groupBy(data, property) {
  return data.reduce(
    (groups, element) => {
      var _a;
      const key = isFunction3(property) ? property(element) : element[property];
      groups[key] = (_a = groups[key]) != null ? _a : [];
      groups[key].push(element);
      return groups;
    },
    {}
  );
}

// src/utils/country.util.ts
var countryList = [
  { value: "AR", label: "Argentina" },
  { value: "AU", label: "Australia" },
  { value: "AT", label: "Austria" },
  { value: "BE", label: "Belgium" },
  { value: "BM", label: "Bermuda" },
  { value: "BG", label: "Bulgaria" },
  { value: "CA", label: "Canada" },
  { value: "KY", label: "Cayman Islands" },
  { value: "CL", label: "Chile" },
  { value: "CO", label: "Colombia" },
  { value: "HR", label: "Croatia" },
  { value: "CY", label: "Cyprus" },
  { value: "CZ", label: "Czech Republic" },
  { value: "DK", label: "Denmark" },
  { value: "EE", label: "Estonia" },
  { value: "FI", label: "Finland" },
  { value: "FR", label: "France" },
  { value: "DE", label: "Germany" },
  { value: "GR", label: "Greece" },
  { value: "GP", label: "Guadeloupe (French territory)" },
  { value: "HK", label: "Hong Kong" },
  { value: "HU", label: "Hungary" },
  { value: "IS", label: "Iceland" },
  { value: "IN", label: "India" },
  { value: "ID", label: "Indonesia" },
  { value: "IE", label: "Ireland" },
  { value: "IL", label: "Israel" },
  { value: "IT", label: "Italy" },
  { value: "JM", label: "Jamaica" },
  { value: "JP", label: "Japan" },
  { value: "LV", label: "Latvia" },
  { value: "LT", label: "Lithuania" },
  { value: "LU", label: "Luxembourg" },
  { value: "MO", label: "Macao" },
  { value: "MY", label: "Malaysia" },
  { value: "MT", label: "Malta" },
  { value: "MX", label: "Mexico" },
  { value: "FM", label: "Micronesia" },
  { value: "NL", label: "Netherlands" },
  { value: "NZ", label: "New Zealand" },
  { value: "NO", label: "Norway" },
  { value: "PY", label: "Paraguay" },
  { value: "PE", label: "Peru" },
  { value: "PH", label: "Philippines" },
  { value: "PL", label: "Poland" },
  { value: "PT", label: "Portugal" },
  { value: "RE", label: "Reunion (French territory)" },
  { value: "RO", label: "Romania" },
  { value: "BL", label: "Saint Barthelemy (French territory)" },
  { value: "RS", label: "Serbia" },
  { value: "SG", label: "Singapore" },
  { value: "SK", label: "Slovakia" },
  { value: "SI", label: "Slovenia" },
  { value: "ZA", label: "South Africa" },
  { value: "KR", label: "South Korea" },
  { value: "ES", label: "Spain" },
  { value: "SE", label: "Sweden" },
  { value: "CH", label: "Switzerland" },
  { value: "TW", label: "Taiwan" },
  { value: "TH", label: "Thailand" },
  { value: "TR", label: "Turkey" },
  { value: "AE", label: "United Arab Emirates" },
  { value: "GB", label: "United Kingdom" },
  { value: "US", label: "United States" },
  { value: "UY", label: "Uruguay" },
  { value: "VN", label: "Vietnam" },
  { value: "VG", label: "Virgin Islands (British)" }
];
var unitedStatesStates = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District Of Columbia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
  { value: "PR", label: "Puerto Rico" },
  { value: "VI", label: "Virgin Islands" },
  { value: "MH", label: "Marshall Islands" },
  { value: "GU", label: "Guam" },
  { value: "MP", label: "Northern Mariana Islands" },
  { value: "AA", label: "Armed Forces (AA)" },
  { value: "AE", label: "Armed Forces (AE)" },
  { value: "AP", label: "Armed Forces (AP)" }
];
var regionNames = new Intl.DisplayNames(["en"], { type: "region" });
var countryIsoToName = (code) => {
  try {
    return regionNames.of(code);
  } catch (error) {
    console.error(error);
    return "";
  }
};
var stateIsoToName = (code) => {
  var _a;
  const iso = code.toUpperCase();
  return ((_a = unitedStatesStates.find((option) => option.value === iso)) == null ? void 0 : _a.label) || code;
};

// src/utils/format.util.ts
var getCurrencyFormatter = (currency, options = {}) => {
  switch (currency) {
    case "USD":
      return new Intl.NumberFormat("en-US", __spreadValues({
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2
      }, options));
    case "CAD":
      return new Intl.NumberFormat("en-CA", __spreadValues({
        style: "currency",
        currency: "CAD",
        minimumFractionDigits: 2
      }, options));
    case "EUR":
      return new Intl.NumberFormat("en-EU", __spreadValues({
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2
      }, options));
    case "GBP":
      return new Intl.NumberFormat("en-GB", __spreadValues({
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 0
      }, options));
    case "AUD":
      return new Intl.NumberFormat("en-AU", __spreadValues({
        style: "currency",
        currency: "AUD",
        minimumFractionDigits: 2
      }, options));
    default:
      return new Intl.NumberFormat("en-US", __spreadValues({
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2
      }, options));
  }
};
var formatCurrency = (value, currency, options) => {
  if (value === void 0 || value === null) return "";
  return getCurrencyFormatter(currency, options).format(value);
};
var formatCount = (count, item) => {
  if (count === 1) return `${count} ${item}`;
  return `${count} ${item}s`;
};

// src/utils/link.util.ts
function createPublicUrl(baseUrl = "/", isDev) {
  return `${baseUrl}${isDev ? `${baseUrl.endsWith("/") ? "" : "/"}public` : ""}`;
}
function rootPath(path) {
  if (path.startsWith("/")) {
    return path;
  }
  return `/${path}`;
}

// src/utils/misc.util.ts
function handleBodyScrollbar(remove) {
  const className = "hide-body-scroll";
  if (remove) {
    if (!document.body.classList.contains(className)) {
      document.body.classList.add(className);
    }
  } else {
    if (document.body.classList.contains(className)) {
      document.body.classList.remove(className);
    }
  }
}
function isValidRegex(pattern) {
  try {
    return !!new RegExp(pattern);
  } catch (error) {
    return false;
  }
}
function disableEnterKeyPress(event) {
  const code = event.keyCode || event.which;
  if (code === 13) {
    event.preventDefault();
  }
}

// src/utils/object.util.ts
function firstKeyValue(object) {
  return object[Object.keys(object)[0]];
}
function firstKeyAndValue(object) {
  const key = Object.keys(object)[0];
  return {
    key,
    value: object[key]
  };
}
function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}
function isSameObject(obj1, obj2) {
  const obj1Keys = Object.keys(obj1);
  const obj2Keys = Object.keys(obj2);
  return obj1Keys.length === obj2Keys.length && obj1Keys.every((key) => obj1[key] === obj2[key]);
}

// src/utils/parse.util.ts
import { isObject, isString } from "@blurb/utils";
function parseErrorMessage(error) {
  if (isString(error)) {
    return error;
  }
  if (isObject(error)) {
    if ("response" in error && isObject(error.response) && "data" in error.response) {
      const data = error.response.data;
      if (isString(data)) {
        return data;
      }
      if (isObject(data)) {
        if ("detail" in data && isString(data.detail)) {
          return data.detail;
        }
        if ("title" in data && isString(data.title)) {
          return data.title;
        }
      }
    }
    return "object error";
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Unknown error";
}

// src/utils/string.util.ts
function capitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

// src/utils/type.util.ts
import { isUndefined as isUndefined2 } from "@blurb/utils";
function isUndefinedAll(values) {
  return values.every((value) => isUndefined2(value));
}

// src/utils/unit.util.ts
var Byte = {
  toMegabyte: (b) => b / (1024 * 1024)
};
var Megabyte = {
  toByte: (mb) => mb * 1024 * 1024,
  format: (mb) => `${mb.toFixed(2)} MB`
};
var Pt = {
  toInches: (pt) => Math.round(pt / 72 * 1e3) / 1e3,
  toCentimeters: (pt) => Math.round(pt * (2.54 / 72) * 1e3) / 1e3
};
var formatDimensions = ({
  width,
  height
}) => {
  const inDim = { width: Pt.toInches(width), height: Pt.toInches(height) };
  const cmDim = {
    width: Pt.toCentimeters(width),
    height: Pt.toCentimeters(height)
  };
  return `${inDim.width} in x ${inDim.height} in / ${cmDim.width} cm x ${cmDim.height} cm`;
};
var formatInDimensions = ({
  width,
  height
}) => {
  const inDim = { width: Pt.toInches(width), height: Pt.toInches(height) };
  return `${inDim.width} in x ${inDim.height} in`;
};

// src/version/index.ts
var formatDate = (date) => {
  return new Date(date).toLocaleString(void 0, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  });
};
function printVersion(data) {
  console.log(
    `%c${document.title}:%c
${[
      ["Branch", data.branch],
      ["SHA", data.sha],
      ["Commit Date", formatDate(data.commitDate)],
      ["Build Date", formatDate(data.buildDate)],
      ["Message", data.message]
    ].map(([name, value]) => `\u2022 ${name}: ${value}`).join("\n")}`,
    "font-weight: bold; font-size: 20px;",
    "font-weight: normal; font-size: 16px;"
  );
}
function loadEnvRibbon(publicUrl, env) {
  return __async(this, null, function* () {
    if (env === "prod") return;
    const isLighthouse = navigator.userAgent.includes("Lighthouse");
    if (isLighthouse) return;
    try {
      const data = yield fetch(`${publicUrl}/version.json`).then(
        (res) => res.json()
      );
      printVersion(data);
      const date = formatDate(data.buildDate);
      const element = document.createElement("div");
      element.className = "env-ribbon";
      element.ariaHidden = "true";
      element.dataset.env = env;
      element.innerHTML = `
    <div>
      <div>${env == null ? void 0 : env.toUpperCase()}</div>
      <div>${date.split(" at ").join("<br/>")}</div>
    </div>
    `;
      document.body.appendChild(element);
    } catch (error) {
      console.error(error);
    }
  });
}
export {
  ArrayActions,
  EventEmitter,
  geo_exports as Geo,
  NavigateHref,
  Optional,
  pdf_preview_exports as PdfPreview,
  Task,
  TaskManager,
  utils_exports as Util,
  assignRef,
  createTask,
  createTaskId,
  isTask,
  loadEnvRibbon,
  mergeRefs,
  useArray,
  useClipboard,
  useDebounce,
  useDebounceCallback,
  useMergeRefs,
  useObjectState,
  useSimplePagination,
  useToggle
};
